module.exports = __webpack_public_path__ + "img/20190622141037微信截图_20190622141435.ad8a78ce.png";